<template>
  <Teleport to="body">
    <transition name="confirm-overlay" appear>
      <div v-if="modelValue" class="modal-overlay confirm-modal-overlay" @click.self="onCancel">
        <transition name="confirm-dialog" appear>
          <div class="confirm-modal" :class="`confirm-modal--${normalizedType}`" role="dialog" aria-modal="true" :aria-label="title">
            <div class="confirm-header">
              <div class="icon">
                <span v-html="getIcon(confirmIcon)"></span>
              </div>
              <h3 class="title">{{ title }}</h3>
            </div>
            <div class="confirm-body">
              <slot name="message">
                <p v-html="message"></p>
              </slot>
            </div>
            <div class="confirm-actions">
              <BaseButton :title="cancelText" variant="cancel" type="button" @click="onCancel" />
              <BaseButton ref="confirmBtnRef" :title="confirmText" :variant="confirmVariant" type="button" @click="onConfirm" />
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </Teleport>
</template>

<script setup>
import { computed, defineEmits, defineProps, nextTick, onMounted, onUnmounted, ref, watch } from "vue";

import BaseButton from "@/components/UiCompunents/BaseButton.vue";
import { getIcon } from "@/utils/icons";

const props = defineProps({
  modelValue: { type: Boolean, required: true },
  title: { type: String, default: "تایید حذف" },
  message: { type: String, default: "آیا از حذف این مورد اطمینان دارید؟" },
  confirmText: { type: String, default: "بله، حذف شود" },
  cancelText: { type: String, default: "انصراف" },
  type: { type: String, default: "delete" }
});

const emit = defineEmits(["update:modelValue", "confirm", "cancel"]);
const confirmBtnRef = ref(null);
const normalizedType = computed(() => props.type === "confirmation" ? "confirmation" : "delete");
const confirmIcon = computed(() => normalizedType.value === "confirmation" ? "check" : "delete");
const confirmVariant = computed(() => normalizedType.value === "confirmation" ? "primary" : "danger");

watch(() => props.modelValue, async (val) => {
  if (!val) return;
  await nextTick();
  const buttonElement = confirmBtnRef.value?.$el || confirmBtnRef.value;
  buttonElement?.focus?.();
});

function onConfirm() {
  emit("confirm");
  emit("update:modelValue", false);
}

function onCancel() {
  emit("cancel");
  emit("update:modelValue", false);
}

function onKeyDown(e) {
  if (props.modelValue && e.key === "Escape") onCancel();
}

onMounted(() => {
  window.addEventListener("keydown", onKeyDown);
});

onUnmounted(() => {
  window.removeEventListener("keydown", onKeyDown);
});
</script>
